import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const FunMathQuizGame = () => {
  const [score, setScore] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [confettiElements, setConfettiElements] = useState([]);
  const [answerValue, setAnswerValue] = useState('');
  const inputRef = useRef(null);

  const questions = [
    { q: "If a car travels 60 km in 2 hours, what’s its speed?", a: 30 },
    { q: "If a person walks at 5 km/h, how far do they walk in 3 hours?", a: 15 },
    { q: "If speed is 20 km/h and distance is 100 km, how long will it take?", a: 5 },
    { q: "If 4 people finish a job in 6 hours, how long will 2 people take?", a: 12 },
    { q: "A train takes 3 hours to cover 240 km. What's its speed?", a: 80 },
    { q: "Ratio of boys to girls is 3:2. If there are 15 boys, how many girls?", a: 10 },
    { q: "Scale up: If 2 pens cost $10, what do 6 pens cost?", a: 30 },
    { q: "What is the ratio of 16 to 8?", a: "2:1" },
    { q: "If a map scale is 1:1000, how long is 3 cm on the ground?", a: 3000 },
    { q: "In a recipe of 4:1 water to syrup, how much syrup for 16 cups of water?", a: 4 },
    { q: "What is 12 × 14?", a: "168" },
{ q: "What is 23 × 15?", a: "345" },
{ q: "What is 34 × 21?", a: "714" },
{ q: "What is 46 × 19?", a: "874" },
{ q: "What is 27 × 18?", a: "486" },
{ q: "What is 24 × 24?", a: "576" },

{ q: "What is 25 × 17?", a: "425" },
{ q: "What is 45 × 9?", a: "405" },
{ q: "What is 22 × 12?", a: "264" },
{ q: "What is 35 × 20?", a: "700" },
    // { q: "Convert 1 meter to centimeters", a: 100 },
    // { q: "Convert 5 kg to grams", a: 5000 },
    // { q: "Convert 2000 ml to liters", a: 2 },
    // { q: "Convert 3.5 liters to milliliters", a: 3500 },
    // { q: "Convert 250 cm to meters", a: 2.5 },
    { q: "In a pie chart of 360°, a section is 90°. What fraction is it?", a: "1/4" },
    { q: "In a pie chart, 180° represents how much of the total?", a: "1/2" },
    { q: "A bar chart shows 20 students like blue, 10 like red. How many total?", a: 30 },
    { q: "Which bar is tallest if the values are 5, 10, 7, 8?", a: 10 },
    { q: "If 3 bars are 8, 6, 10 units high, what’s the average height?", a: 8 },
    { q: "Find the mean of: 4, 8, 6", a: 6 },
    { q: "Find the mode: 2, 3, 3, 5, 6", a: 3 },
    { q: "Find the mode: 2, 5, 5, 5, 6", a: 5 },
    { q: "Find the median: 1, 2, 5, 7, 9", a: 5 },
    { q: "What is the range of: 3, 9, 5, 12, 4", a: 9 },
    // { q: "If tally marks show |||| |||, how many items?", a: 7 },
    // { q: "A tank holds 3 liters. How many ml is that?", a: 3000 },
    // { q: "If 100g of sugar makes 10 cookies, how much for 50 cookies?", a: 500 },
    // { q: "If a car moves 80 km in 1 hour, how far in 2.5 hours?", a: 200 },
    // { q: "If you double a recipe that calls for 1.5 L of milk, how much do you need?", a: 3 },
    // { q: "You need 6 meters of ribbon. You have 480 cm. How much more?", a: 120 }
  ];

  const normalizeAnswer = (input) => input.trim().toLowerCase().replace(/\s+/g, '');

  const checkAnswer = (e) => {
    e.preventDefault();
    const userAnswerRaw = answerValue;
    const correctAnswer = questions[currentQuestionIndex].a;
    let isCorrect = false;

    if (typeof correctAnswer === 'number') {
      isCorrect = Number(userAnswerRaw) === correctAnswer;
    } else {
      isCorrect = normalizeAnswer(userAnswerRaw) === normalizeAnswer(correctAnswer);
    }

    if (isCorrect) {
      setScore((prev) => prev + 1);
      setFeedback('🎉 Correct!');
      setFeedbackColor('#2e7d32');
      showConfetti();
    } else {
      setFeedback(`❌ Wrong! The correct answer is: ${correctAnswer}`);
      setFeedbackColor('#c62828');
    }

    // Wait 2 seconds before next question
    setTimeout(() => {
      setCurrentQuestionIndex((prev) => prev + 1);
      setFeedback('');
    }, 2000);
  };

  // Clear input & focus when question changes
  useEffect(() => {
    setAnswerValue('');
    inputRef.current?.focus();
  }, [currentQuestionIndex]);

  const showConfetti = () => {
    const elements = [];
    for (let i = 0; i < 30; i++) {
      elements.push(
        <div
          key={i + Math.random()}
          style={{
            position: 'fixed',
            width: '10px',
            height: '10px',
            backgroundColor: `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`,
            opacity: 0.8,
            pointerEvents: 'none',
            animation: `fall ${2 + Math.random() * 2}s linear forwards`,
            left: Math.random() * window.innerWidth + 'px'
          }}
        ></div>
      );
    }
    setConfettiElements(elements);
    setTimeout(() => setConfettiElements([]), 3000);
  };

  const question = questions[currentQuestionIndex];

  useEffect(() => {
    if (currentQuestionIndex === questions.length) {
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  }, [currentQuestionIndex]);

  return (
    <div style={{ 
      fontFamily: 'Poppins, sans-serif',
      backgroundImage: 'url("https://static.vecteezy.com/system/resources/thumbnails/021/826/876/small_2x/hand-drawn-math-symbols-icon-in-flat-style-mathematics-formula-illustration-on-isolated-background-school-education-sign-business-concept-vector.jpg")',
      minHeight: '100vh',
      overflowX: 'hidden'
    }}>
      {confettiElements}
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: '20px' }}>
        <div style={{ background: '#fff', border: '3px solid #4a148c', borderRadius: '30px', padding: '40px 30px 50px', maxWidth: '500px', width: '90%', textAlign: 'center' }}>
          <h2 style={{ fontSize: '34px', color: '#4a148c', fontFamily: 'Comic Neue, cursive', textShadow: '1px 1px 3px #b39ddb' }}>
            Score → <span>{score}</span>
          </h2>
          <h3 style={{ fontSize: '22px', margin: '20px 0 30px', minHeight: '3em' }}>
            {question ? question.q : `🎉 Quiz Complete! Your final score is ${score} / ${questions.length}`}
          </h3>
          {question && (
            <form onSubmit={checkAnswer} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
              <input
                ref={inputRef}
                name="answer"
                type="text"
                required
                autoComplete="off"
                inputMode="numeric"
                value={answerValue}
                onChange={(e) => setAnswerValue(e.target.value)}
                style={{ fontSize: '22px', padding: '15px', border: '2px solid #4a148c', borderRadius: '15px', textAlign: 'center' }}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: '1rem' }}>
  <button
    type="button"
    onClick={() => {
      setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0));
      setFeedback('');
    }}
    style={{
      flex: 1,
      padding: '1rem',
      backgroundColor: '#6a1b9a',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: 700,
      border: 'none',
      borderRadius: '15px',
      cursor: currentQuestionIndex === 0 ? 'not-allowed' : 'pointer',
      opacity: currentQuestionIndex === 0 ? 0.5 : 1,
    }}
    disabled={currentQuestionIndex === 0}
  >
    Previous
  </button>

  <button
    type="button"
    onClick={() => {
      setCurrentQuestionIndex((prev) =>
        Math.min(prev + 1, questions.length - 1)
      );
      setFeedback('');
    }}
    style={{
      flex: 1,
      padding: '1rem',
      backgroundColor: '#4a148c',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: 700,
      border: 'none',
      borderRadius: '15px',
      cursor:
        currentQuestionIndex === questions.length - 1 ? 'not-allowed' : 'pointer',
      opacity: currentQuestionIndex === questions.length - 1 ? 0.5 : 1,
    }}
    disabled={currentQuestionIndex === questions.length - 1}
  >
    Next
  </button>
</div>

              <button
                type="submit"
                style={{ padding: '15px', backgroundColor: '#4a148c', color: '#fff', fontSize: '24px', fontWeight: 700, border: 'none', borderRadius: '15px', cursor: 'pointer' }}
              >
                Submit
              </button>
            </form>
          )}
          <div style={{ fontSize: '20px', marginTop: '15px', height: '30px', fontWeight: 700, fontFamily: 'Comic Neue, cursive', color: feedbackColor }}>
            {feedback}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes fall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(600px) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default FunMathQuizGame;
